import axios from 'axios';
import Vue from 'vue';
import GrooveUIKitV2 from '../../groove-ui-kit-v2/src/vue2/groove-ui-kit';
import GsNamedModal from '../../groove-ui-kit-v2/src/vue2/named-modal-adapter';
import '../../groove-ui-kit-v2/src/styles/groove-ui-kit.css';
import '../../groove-ui-kit-v2/src/styles/refresh-controls.css';

Vue.use(GrooveUIKitV2);
Vue.component('gs-named-modal', GsNamedModal);
import App from './components/App.vue';
import store from './state';
import router from './router';
import wait from './plugins/wait';
import './components';
import './plugins';
import '@groovepages/gd-ui-kit/styles.css';
import config from '../../load-config';
import i18n from './plugins/i18n';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(VueObserveVisibility)

config.then(configValues => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}/groovevideo`;

  try {
        if ('localStorage' in window && window.localStorage)
        {
            const user = JSON.parse(localStorage.getItem('user') || '{}'); 
            if (!user.auth_keycloak)
            {
                axios.defaults.headers.common = {
                ...axios.defaults.headers.common,
                'x-auth-provider': 'auth0'
                };
            }
        }
   }
   catch (exception) { 
       console.log('unable to access localstorage');
   }


  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }

  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}/groovevideo`,
    appUrl: `${configValues.VUE_APP_GROOVEVIDEO_URL}`,
    grooveappsurl: appFrontendURL,
    apiCoreUrl: `${configValues.VUE_APP_API_URL}`
  };
  window.config = localConfig;
  window.gdEnv = configValues;

  Vue.config.productionTip = false;

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    store,
    router,
    wait,
    ...App
  });
});
